import { __generator } from "tslib";
import { all, put, select } from 'redux-saga/effects';
import { selectors, withOffset } from '../../Stream';
import { DEVIATIONS_PER_FETCH, MEDIA_POPUP_TIER_DEVIATION_STREAM_GROUP, } from '../constants';
import { getTierDeviationsStreamId } from '../helpers';
import { getCurrentMediaSource, getMode, getCurrentTierId } from '../selectors';
import { MediaPopupMode } from '../types';
function handleInitTierDeviationStream() {
    var _a, mode, mediaSource, tierId, streamId, isStreamInitialized, cacheStreams, streamParams;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(function (state) { return ({
                    mode: getMode(state),
                    mediaSource: getCurrentMediaSource(state),
                    tierId: getCurrentTierId(state),
                }); })];
            case 1:
                _a = _b.sent(), mode = _a.mode, mediaSource = _a.mediaSource, tierId = _a.tierId;
                streamId = getTierDeviationsStreamId(mediaSource, tierId);
                return [4 /*yield*/, select(selectors.isInitialized, streamId)];
            case 2:
                isStreamInitialized = _b.sent();
                cacheStreams = true;
                if (mode === MediaPopupMode.MANAGER) {
                    cacheStreams = false;
                }
                if (isStreamInitialized && cacheStreams) {
                    return [2 /*return*/];
                }
                streamParams = {
                    mediaSource: mediaSource,
                    tierId: tierId,
                };
                return [4 /*yield*/, all([
                        put(withOffset.actions.initialize({
                            streamId: streamId,
                            groupId: MEDIA_POPUP_TIER_DEVIATION_STREAM_GROUP,
                            streamParams: streamParams,
                            itemsPerFetch: DEVIATIONS_PER_FETCH,
                            hasMore: true,
                        })),
                        put(withOffset.actions.fetch(streamId)),
                    ])];
            case 3:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
export default handleInitTierDeviationStream;
//# sourceMappingURL=initTierDeviationStream.js.map